<template>
	<AlertCardWrapper @action-button-click="actionButtonClick" :actionTitle="actionTitle" :titleArr="titleArr" :alert="alert">
		<template #subtitle>
			<SubTitle :hideIcon="hideIcon" :text="subtitleText" />
		</template>
	</AlertCardWrapper>
</template>

<script>
import AlertTypeBaseMixin from '../mixins/AlertTypeBaseMixin';
export default {
	name: 'SyncedGroupTurnedOffAlert',
	mixins: [AlertTypeBaseMixin],
	computed: {
		titleArr() {
			return [{ text: 'Synced group turned off due to reaching the limit of allowed errors' }];
		},
		actionTitle() {
			return 'Go to settings';
		},
		subtitleText() {
			return 'Might be because to the connection related to the group';
		},
	},
	methods: {
		actionButtonClick() {
			this.$router.push({ name: 'ManageSingleGroup', params: { groupId: this.alert.entity_id } });
			this.markAlertAsCompleted();
		},
	},
};
</script>
<style lang="scss" scoped></style>
